// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__p4MY2","footer":"ChangeClinic_footer__2JPa_"};